<template>
  <div>
    <el-button
      type="primary"
      round
      @click="back"
      size="mini"
      style="margin: 10px 0;margin-left: 10%;"
      >返回</el-button
    >
    <div class="wrapCon">
      <div class="left">
        <h3 style="font-size: 18px !important">在线办理</h3>
        <div class="linkCon">
          <div :class="index == 1 ? 'active' : 'link'" @click="clickLink(1)">
            电话办理
          </div>
          <div :class="index == 2 ? 'active' : 'link'" @click="clickLink(2)">
            电子税务局
          </div>
          <div :class="index == 3 ? 'active' : 'link'" @click="clickLink(3)">
            远程视频协助二维码
          </div>
        </div>
      </div>
      <div class="right">
        <div v-show="index == 1">
          <div class="right_top">
            <div class="title">
              <span class="fontStyle">电话办理</span>
            </div>
            <div class="content">
              您的主管税务机关是：国家税务总局信阳市第一税务分局，办税热线电话是：0395-2935609
            </div>
          </div>
        </div>
        <div v-show="index == 2">
          <div class="right_top">
            <div class="title">
              <span class="fontStyle">主管税务机关电话</span>
            </div>
          </div>
          <div class="middle" style="margin-top: 10px">
            <p style="margin: 10px auto">
              您的主管税务机关是：国家税务总局信阳市第一税务分局，咨询热线电话是：0395-2935609
            </p>
          </div>
        </div>
        <div v-show="index == 3">
          <div class="right_top">
            <div class="title">
              <span class="fontStyle">远程视频协助二维码</span>
            </div>
          </div>
          <div class="middle devide" style="margin-top: 10px">
            <img
              class="qrcode"
              src="~@/assets/images/image.png"
              alt=""
              width="300px"
            />
            <div class="txt">
              <p>（一）使用手机钉钉软件使用手机钉钉扫描群二维码入群，进行远程协助在线预约。</p>
              <p style="text-align:justify;">（二）预约成功后使用手机钉钉或则电脑版钉钉，参加由税务人员发起的视频会议进行税费业务远程办理。</p>
              <p>（三）涉税业务办理完成后请对办理流程进行评价。</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      index: 1,
      headerStyle: {
        color: "#000",
        background: "#ccc",
      },
      tableData: [
        {
          name: "国家税务总局信阳市税务局第一税务分局办税服务厅",
          phone: "0395-2935609",
        },
        {
          name: "国家税务总局信阳市源汇区税务局办税服务厅",
          phone: "0395-2122591",
        },
        {
          name: "国家税务总局信阳市郾城区税务局办税服务厅",
          phone: "0395-5351561",
        },
        {
          name: "国家税务总局信阳市召陵区税务局办税服务厅",
          phone: "0395-2160832",
        },
        {
          name: "国家税务总局舞阳县税务局办税服务厅",
          phone: "0395-7190086",
        },
        {
          name: "国家税务总局临颍县税务局办税服务厅",
          phone: "0395-8819223",
        },
        {
          name: "国家税务总局信阳市税务局第二税务分局办税服务厅",
          phone: "0395-5691126",
        },
        {
          name: "国家税务总局信阳经济技术开发区税务局办税服务厅",
          phone: "0395-2665526",
        },
      ],
    };
  },
  created() {},
  mounted() {},
  methods: {
    back() {
      this.$parent.topNav = true;
      this.$parent.showFlag = "";
      // this.$router.push({ name: "policyService" });
    },
    clickLink(param) {
      this.index = param;
      if (param == 2) {
        this.$confirm("即将跳转到国家税务总局河南省电子税务局官网")
          .then(() => {
            // done();
            let href =
              "https://etax.henan.chinatax.gov.cn/web/dzswj/ythclient/mh.html";
            window.open(href, "_blank");
          })
          .catch((_) => {});
        this.index = 1;
      }
    },
  },
};
</script>

<style lang='scss' scoped>
$width: 1150px;
.fontStyle {
  font-size: 18px;
  font-weight: 700;
  color: #000;
}
.back {
  cursor: pointer;
  margin: 0 auto;
}
.wrapCon {
  width: $width;
  min-height: 200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  .left {
    width: 20%;
    background: #f7f7f7;
    padding: 20px 0;
    // border: 1px solid #ccc;
    h3 {
      text-align: center;
      color: #fff;
      font-size: 22px;
      margin-bottom: 5px;
      margin: 0px auto;
      background-color: #0241FF;
      line-height: 64px;
    }
    .linkCon {
      div {
        cursor: pointer;
        font-size: 18px;
        width: 88%;
        margin: 10px auto;
        text-align: center;
        border: 1px solid #ddd;
        line-height: 52px;
        border-radius: 5px;
        background-color: #fff;
        &:hover {
          color: #fff;
          background-color: #1472FF;
        }
      }
      .active {
        color: #fff;
        background-color: #1472FF;
      }
    }
  }
  .right {
    width: 78%;
    min-height: 400px;
    border-left: 1px solid #ccc;
    padding-left: 20px;
    .right_top {
      width: 100%;
      .title {
        height: 64px;
        border-bottom: 1px solid #ccc;
        span {
          display: inline-block;
          min-width: 110px;
          height: 100%;
          text-align: center;
          line-height: 64px;
          border-bottom: 3px solid #1472FF;
        }
      }
      .content {
        background-color: #ebf6fc;
        padding: 20px;
        margin-top: 10px;
        margin-bottom: 40px;
      }
    }
    .middle {
      background-color: #ebf6fc;
      padding: 20px;
    }
    .devide {
      display:flex;
      align-items:center;
      .txt {
        p {
          padding:0 10px;
          margin:15px;
        }
      }
    }
  }
}
</style>
